import { render } from "./CustomFieldEditorElement.vue?vue&type=template&id=705a1a26&scoped=true&ts=true"
import script from "./CustomFieldEditorElement.vue?vue&type=script&lang=ts"
export * from "./CustomFieldEditorElement.vue?vue&type=script&lang=ts"

import "./CustomFieldEditorElement.vue?vue&type=style&index=0&id=705a1a26&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-705a1a26"]])

export default __exports__